// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c1a64fab","139":"6c960ffb","716":"0ef39b3d","928":"7434ae97","974":"5a7d8c3c"}[chunkId] + ".chunk.js";
};